// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.nolimit .dialog {
    border: 0.2em solid rgba(255, 255, 255, 0.5);
    border-radius: 2em;
    background-clip: padding-box;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;
    padding-top: 0em;
    padding-right: 4em;
    padding-left: 4em;
    padding-bottom: 0em;
    font-weight: 200;
    overflow: hidden;
    height:auto;
    width:auto;
    max-width: 90%;
    max-height: 90%;
}

.nolimit .dialog, .nolimit .dialog a {
    color: #fbf800;
}
.nolimit .dialog a {
    font-size:1.4em
}

.nolimit .dialog a:hover {
    font-weight: 400;
}

.nolimit .hidden {
    position: absolute;
    left: -200vw;
    padding: 0;
    margin: 0;
}

.nolimit .hidden .dialog {
    width: 70vw;
    max-height: 90%;
    height: auto;

}

.nolimit .dialog h1, .nolimit .dialog p, .nolimit .dialog ul {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.nolimit .dialog h1, .nolimit .dialog h2 {
    color: white;
    margin-top: 1em;
    margin-bottom: 1em;
    font-weight: 300;
}

.nolimit .dialog h1 {
    font-size: 3em;
}

.nolimit .dialog h2 {
    font-size: 2.8em;
}

.nolimit .dialog ul {
    list-style: none none;
    font-size: 1.6em;
    padding: 0;
}

.nolimit .dialog p {
    margin: 1em;
    font-weight: 200;
    font-size: 1.7em;
}

.nolimit .dialog .grid {
    width: 100%;
    display: table;
    table-layout: fixed;
}

.nolimit .dialog .grid > * {
    display: table-cell;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nolimitcity/game-api/src/css/dialog.css"],"names":[],"mappings":";AACA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,4BAA4B;IAC5B,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;;AAEhB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["\n.nolimit .dialog {\n    border: 0.2em solid rgba(255, 255, 255, 0.5);\n    border-radius: 2em;\n    background-clip: padding-box;\n    background-color: rgba(0, 0, 0, 0.5);\n    text-align: center;\n    padding-top: 0em;\n    padding-right: 4em;\n    padding-left: 4em;\n    padding-bottom: 0em;\n    font-weight: 200;\n    overflow: hidden;\n    height:auto;\n    width:auto;\n    max-width: 90%;\n    max-height: 90%;\n}\n\n.nolimit .dialog, .nolimit .dialog a {\n    color: #fbf800;\n}\n.nolimit .dialog a {\n    font-size:1.4em\n}\n\n.nolimit .dialog a:hover {\n    font-weight: 400;\n}\n\n.nolimit .hidden {\n    position: absolute;\n    left: -200vw;\n    padding: 0;\n    margin: 0;\n}\n\n.nolimit .hidden .dialog {\n    width: 70vw;\n    max-height: 90%;\n    height: auto;\n\n}\n\n.nolimit .dialog h1, .nolimit .dialog p, .nolimit .dialog ul {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n\n.nolimit .dialog h1, .nolimit .dialog h2 {\n    color: white;\n    margin-top: 1em;\n    margin-bottom: 1em;\n    font-weight: 300;\n}\n\n.nolimit .dialog h1 {\n    font-size: 3em;\n}\n\n.nolimit .dialog h2 {\n    font-size: 2.8em;\n}\n\n.nolimit .dialog ul {\n    list-style: none none;\n    font-size: 1.6em;\n    padding: 0;\n}\n\n.nolimit .dialog p {\n    margin: 1em;\n    font-weight: 200;\n    font-size: 1.7em;\n}\n\n.nolimit .dialog .grid {\n    width: 100%;\n    display: table;\n    table-layout: fixed;\n}\n\n.nolimit .dialog .grid > * {\n    display: table-cell;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
